export default "__VITE_ASSET__DPvFynKs__"